import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const getDocumentCalculationFieldsList = createSelector(
  getSystem,
  ({ documentCalculationFields }) => Object.values(documentCalculationFields || {}),
);

export const getDocumentCalculationFieldById = memoizeOne(id =>
  createSelector(
    getSystem,
    ({ documentCalculationFields }) => documentCalculationFields?.[id] || null,
  ),
);
